module.exports = __webpack_public_path__ + "img/timer_clock_pause.90394c7b.svg";